var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("auto.trendyolFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.integration"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.trendyolEntegration,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "trendyolEntegration", $$v)
                },
                expression: "featureForm.trendyolEntegration",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.channelCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.trendyolChannelCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "trendyolChannelCount", $$v)
                },
                expression: "featureForm.trendyolChannelCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.questionAnswerManagement"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.trendyolQuestionAnswer,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "trendyolQuestionAnswer", $$v)
                },
                expression: "featureForm.trendyolQuestionAnswer",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.automaticAnswerSystem"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.trendyolAutomaticAnswer,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "trendyolAutomaticAnswer", $$v)
                },
                expression: "featureForm.trendyolAutomaticAnswer",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("auto.chatbotCommentControl"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.trendyolCommentChatbotManage,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "trendyolCommentChatbotManage", $$v)
                },
                expression: "featureForm.trendyolCommentChatbotManage",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }